(function ($) {
  Drupal.behaviors.anr_repromote_hero_mob_v1 = {
    attach: function (context) {
      $('#anr_repromote_mod1', context).once(function (idx, element) {
        const $thismodule = $(element);
        const triggerMod = '#anr_repromote_mod1';
        const thisModuleName = 'anr_repromote_mod1';
        const controller = new ScrollMagic.Controller();
        const moduleWillFade = $thismodule.data('scrollmagic') === 1;
        const $stars = $('.js-anr_repromote__star');
        const urlHash = window.location.href.split('#')[1];
        let animDelay = 250;
        let hasFaded = false;
        let offset, fadeThisModuleScene, randomNum;
        let mppTarget,
          $thisparent = $thismodule.parent();

        if ($thisparent.parents('.node-elc-nodeblock').length) {
          mppTarget = $thismodule.parents().eq(3).prev('.mpp');
        } else {
          mppTarget = $thismodule.parent().prev('.mpp');
        }

        const targetDetach = mppTarget.find('.product-brief'),
          targetAttach = $thismodule.find('.js-anr_repromote__hero-block_qs'),
          targetQSOpen_1 = mppTarget.find(
            'a.button__quickshop.product-brief__button-quickshop.js-quickshop-show'
          ),
          targetQSClose_1 = mppTarget.find(
            'a.product-brief__button-quickshop--close.js-quickshop-hide'
          );

        // If module is called in URL, scroll to module.
        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // Handle the hero text fade-in
        $thismodule
          .find(
            '.js-anr_repromote_mod1__anim1, .js-anr_repromote_mod1__anim2, .js-anr_repromote_mod1__anim3, .js-anr_repromote_mod1__anim4, .js-anr_repromote_mod1__anim5, .js-anr_repromote_mod1__anim6'
          )
          .animate(
            {
              opacity: '0',
              'margin-top': '+=5%'
            },
            0
          );

        // Handle the star animations.
        $stars.each(function (i) {
          const $this = $(this);

          randomNum = Math.floor(Math.random() * 5) + 1;
          setTimeout(function () {
            $this.addClass('fadeStarsInOut');
          }, 50 * randomNum * i);
        });

        // Append Quickshop on Mobile
        function appendMobQuickshop() {
          if ($(window).width() <= 768) {
            mppTarget.addClass('mpp_qs_detached');
            mppTarget.detach().insertAfter($thisparent);
            targetQSOpen_1.addClass('shop_now_dark shop_now_centered');
            targetQSClose_1.addClass('shop_now_light shop_now_white shop_now_centered');
            // Need to wait for mpp to load.
            $(window).on('load', function () {
              targetDetach.detach().insertAfter(targetAttach);
              mppTarget.detach().appendTo($thismodule);
            });
          }
        }
        appendMobQuickshop();

        $(window).on('load', function () {
          for (let i = 1; i <= 6; i++) {
            animDelay += 200;
            $thismodule
              .find('.js-anr_repromote_mod1__anim' + i)
              .delay(animDelay)
              .animate(
                {
                  opacity: 1,
                  'margin-top': '-=5%'
                },
                500
              );
          }

          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });
            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
